module.exports = __webpack_public_path__ + "static/scale-model-of-northland-sales-inc-in-fargo-north-dakota-56a318ac8da7718a2d1b717e232a9cf6.png";